export default {
  mutationTypes: {
    start: 'START_EDIT_ADDRESS',
    change: 'CHANGE_ADDRESS',
    cancel: 'CANCEL_EDIT_ADDRESS',
    save: 'SAVE_EDIT_ADDRESS',
    load: 'LOAD_ADDRESS',
  },
};
